export const PICKUP_INFORMATION = 'PickupInformation';
